import { Link } from '@/i18n/navigation';
import { AnimatePresence, motion } from 'motion/react';
import Image from 'next/image';
import { DetailedHTMLProps, HTMLAttributes } from 'react';

export type LogoOwnProps = {
  variant?: 'light' | 'dark';
  href?: string;
  noName?: boolean;
};

export type LogoProps = LogoOwnProps &
  Omit<DetailedHTMLProps<HTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'popover'>;

export default function Logo({
  variant = 'light',
  href = '/',
  noName,
  style,
  ...props
}: LogoProps) {
  const sources = {
    light: '/logo.png',
    dark: '/logo-dark.png',
  };

  // Animation
  const variants = {
    enter: { opacity: 0 },
    shown: { opacity: 1 },
    exit: { opacity: 0 },
  };

  return (
    <Link
      href={href}
      style={{
        display: 'flex',
        alignItems: 'center',
        textDecoration: 'none',
        gap: '1em',
        ...style,
      }}
      {...props}
    >
      <AnimatePresence mode="wait">
        <motion.div
          key={variant}
          variants={variants}
          initial="enter"
          animate="shown"
          exit="exit"
          transition={{ duration: 0.3 }}
        >
          <Image
            width={64}
            height={64}
            alt="Logo"
            src={sources[variant]}
            style={{ filter: 'drop-shadow(0 0 5px #0002)' }}
          />
        </motion.div>
      </AnimatePresence>
      {!noName && (
        <span
          style={{
            fontWeight: 'bold',
            fontFamily: 'var(--font-button)',
            color: 'var(--color-heading)',
          }}
        >
          Federico Mantovani
        </span>
      )}
    </Link>
  );
}
